<template>
  <div>
    <div class="bussiness_services_bg">
      <div class="top_image_nav">
        <img src="../assets/image/login/smallWeiTu.png" class="small_image">
        <span class="title_span">零钱口袋</span>
        <div class="tab_box">
          <el-tabs v-model="activeName2" @tab-click="handleClick2">
            <el-tab-pane label="首页" name="/"></el-tab-pane>
            <el-tab-pane label="企业服务" name="businessServices" ></el-tab-pane>
            <el-tab-pane label="关于我们" name="aboutUs"></el-tab-pane>
            <el-tab-pane label="登录" name="login"></el-tab-pane>
            <el-tab-pane label="注册" name="reg"></el-tab-pane>
            <el-tab-pane label="企业注册" name="enterpriseReg"></el-tab-pane>
            <el-tab-pane label="渠道代理注册" name="channelReg"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <button class="posts_btn_style" @click="toLogin">发布职位</button>
    </div>
    <div class="bs_middle_box" id="qualityService">
      <img src="../assets/image/bussinessServesImg/bsWeiTu1.png" class="bs_image_one"/>
      <span class="bs_word_one">兼职、实习招聘海量优质人才 精准匹配快速招聘到岗</span>
      <span class="bs_word_tow">加入精选热门岗位 超多曝光量，招人更快更轻松</span>
      <img src="../assets/image/bussinessServesImg/bsWeiTu2.png" class="bs_image_tow"/>
      <img src="../assets/image/bussinessServesImg/bsWeiTu3.png" class="bs_image_three">
      <span class="bs_word_three">免费发布职位 报名数量有保障</span>
      <span class="bs_bottom_title" id="merchantsMove">立即成为商家，开始招聘吧！</span>
      <button class="bg_bottom_btn" @click="toLogin()">一键入驻</button>
    </div>
    <div class="index_bottom_box">
      <img src="../assets/image/index1/huanBan1.png" style="margin-top: 11rem;margin-left: 28.5rem;"/>
      <span class="bottom_company_name">厦门口袋零钱网络科技有限公司</span>
      <span class="shou_ye">首页</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 54.2rem;color: #FFFFFF">|</span>
      <span class="qi_ye">企业服务</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 64.6rem;color: #FFFFFF">|</span>
      <span class="guan_yu">关于我们</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 74.6rem;color: #FFFFFF">|</span>
      <span class="guan_yu" style="margin-left: 77.8rem">联系我们</span>
      <ul>
        <li style="color: #8E9DC3;width: 4.3rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/#companyProduct"style="color: #8E9DC3;">旗下产品</a></li>
        <li style="color: #8E9DC3;width: 4.3rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/#recuirtService" style="color: #8E9DC3;">招聘服务</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/#ourPhilosophy" style="color: #8E9DC3;">我们的理念</a></li>
      </ul>
      <ul>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 57.85rem;margin-top: -7.2rem;list-style: none"><a style="color: #8E9DC3;" href="/businessServices#qualityService">优质服务</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 57.85rem;margin-top: 1.8rem;list-style: none"><a style="color: #8E9DC3;" href="/businessServices#merchantsMove">商家入驻</a></li>
      </ul>
      <ul>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: -4.2REM;list-style: none"><a style="color: #8E9DC3;" href="/aboutUs#companyProfile">公司简介</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: 1.8rem;list-style: none"><a style="color: #8E9DC3;" href="/aboutUs#contanctUs">联系我们</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: 1.8rem;list-style: none"><a style="color: #8E9DC3;" href="/aboutUs#moreQuestion">常见问题</a></li>
      </ul>
      <ul>

        <li style="color: #8E9DC3;width: 9.8rem;height: 1.25rem;margin-left: 77.85rem;margin-top: -4.2rem;list-style: none">商务合作邮箱：3348759773@qq.com</li>
        <li style="color: #8E9DC3;width: 9.8rem;height: 1.25rem;margin-left: 77.85rem;margin-top: -4.2rem;list-style: none">客服热线：&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp 0592-5535810</li>
      </ul>
      <div class="bottom_bg">
        <span class="bottom_bg_span">© 2021 厦门口袋零钱网络科技有限公司. 版权所有 </span>
      </div>
    </div>
  </div>
</template>

<script>
const urls = require('../../url');
export default {
name: "businessServices",
  data(){
    return{
      activeName2: 'businessServices',
    }
  },
  methods:{
    handleClick2(tab) {
      if(tab.paneName==='login'){
        window.location.href=urls.loginUrl+'?tabs=0';
      }else if(tab.paneName==='reg'||tab.paneName==='enterpriseReg'||tab.paneName==='channelReg'){
        window.location.href=urls.loginUrl+'?tabs=1';
      }else{
        this.$router.push(tab.paneName)
      }
    },
    toLogin(){
       window.location.href=urls.loginUrl;
      // window.location.href='../../static/service.html';
    },
  }
}
</script>

<style>
.bussiness_services_bg{
  width: 100%;
  height: 45rem;
  background-image: url("../assets/image/bussinessServesImg/topBanner.png");
  background-repeat: no-repeat;
  background-size: auto 100%;
  position: relative;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.top_image_nav{
  position: absolute;
  width: 85%;
  height: 5rem;
  top: 5rem;
  left: 8.125rem;
}

.small_image {
  display: block;
  margin-left: 0.1rem;
  margin-top: 1.1rem;
}

.title_span {
  color: white;
  font-size: 28px;
  display: block;
  margin-left: 56px;
  margin-top: -41px;
}

.bs_middle_box{
  width: 100%;
  height: 90.8rem;
}
.bs_image_one{
  max-width: 100%;
  height: auto;
  margin-left: 22.4rem;
  margin-top: 1.4rem;
}
.bs_word_one{
  width: 19.5rem;
  height: 3.4rem;
  display: block;
  color: #333333;
  font-size: 1.5rem;
  margin-left: 49.2rem;
  margin-top: -15.6rem;
}
.bs_word_tow{
  width: 19.5rem;
  height: 3.4rem;
  display: block;
  color: #333333;
  font-size: 1.5rem;
  margin-left: 50.6rem;
  margin-top: 19.6rem;
}
.bs_image_tow{
  margin-left: 70rem;
  margin-top: -13rem;
}
.bs_image_three{
  margin-left: 22.4rem;
  margin-top: -6rem;
}
.bs_word_three{
  width: 10.5rem;
  height: 3.5rem;
  display: block;
  color: #333333;
  font-size: 1.5rem;
  margin-left: 50.4rem;
  margin-top: -15rem;
}
.bs_bottom_title{
  width: 38.4rem;
  height: 4.1rem;
  color: #333333;
  font-size: 2.9rem;
  display: block;
  margin-left: 41.3rem;
  margin-top: 15.1rem;
}
.bg_bottom_btn{
  width: 13.75rem;
  height: 3.75rem;
  background-color: #0729BF;
  border-radius: 1.875rem;
  border: none;
  color: white;
  margin-left: 53.125rem;
  margin-top: 2.5rem;
}
.posts_btn_style{
  width: 13.75rem;
  height: 3.75rem;
  border-radius: 1.9rem;
  border: none;
  background-color: white;
  color: #0729BF;
  font-weight: 550;
  z-index: 999;
  position: absolute;
  top: 31.75rem;
  left: 22.88rem;
}
/*去除标签页下的线*/
.el-tabs__nav-wrap:after {
  background-color: transparent;
}
/*修改线的位置*/
.el-tabs__active-bar {
  bottom: 0.45rem;
}
/*修改标签颜色*/
.el-tabs__item.is-active {
  color: white;
}
.el-tabs__item {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/businessServices.vue